let onCompleted;

$(document).ready(function() {
    const $newsletterForm = $('.js-newsletter-form');

    if ($newsletterForm.length) {
        $newsletterForm.validate({
            errorPlacement: function (error, element) {
                if (element.attr('type').match('checkbox')) {
                    error.insertAfter(element.siblings('label'));
                } else {
                    error.insertAfter(element);
                }
            },
            submitHandler: function (form) {
                const $emailInput = $('.js-newsletter-email'),
                    $newsletterMessage = $('.js-newsletter-message'),
                    $captchaWrapper = $newsletterForm.find(".captcha-wrapper"),
                    $submitButton = $('.js-newsletter-submit'),
                    $consentCheckbox = $('.newsletter-consents').find('input[type="checkbox"]');

                // Check if captcha is enabled by checking if wrapper has content
                const hasCaptcha = $captchaWrapper.length && $captchaWrapper.children().length > 0;

                $newsletterMessage.slideUp(150);
                $emailInput.prop('readonly', true);

                // Show captcha if it exists and has content
                if (hasCaptcha) {
                    $captchaWrapper.slideDown();

                    onCompleted = function() {
                        $captchaWrapper.slideUp(250);
                        processForm();
                    };
                } else {
                    // Process form immediately if no captcha
                    processForm();
                }

                function processForm() {
                    $submitButton
                        .prop('disabled', true)
                        .addClass('is-loading');

                    Form.ajaxPost(form, function (data) {
                        let msg = data.msg.format;

                        if (!msg) {
                            msg = data.msg;
                        }

                        $newsletterMessage.html(msg);
                        $newsletterMessage.toggleClass('c-msg--error', !data.status);
                        $newsletterMessage.toggleClass('c-msg--success', data.status);

                        if (!data.status) {
                            $emailInput.addClass('error').focus();
                        }
                        else {
                            $emailInput.val('');

                            window.dataLayer = window.dataLayer || [];

                            dataLayer.push({
                                'event': 'newsletter-sign-up'
                            });
                        }

                        // Reset captcha if it exists
                        if (hasCaptcha && typeof resetAllCaptcha === 'function') {
                            resetAllCaptcha();
                        }

                        $emailInput.prop('readonly', false);
                        $consentCheckbox.prop('checked', false);
                        $submitButton.prop('disabled', false).removeClass('is-loading');
                        $newsletterMessage.slideDown(250);
                    }, 'json');
                }

                return false;
            }
        });
    }

    $('.slider-benefits')
        .slick({
            dots: false,
            arrows: true,
            infinite: false,
            adaptiveHeight: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: $('.slider__benefits__prev'),
            nextArrow: $('.slider__benefits__next'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3.2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 2.6,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 560,
                    settings: {
                        slidesToShow: 2.2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.8,
                        slidesToScroll: 1,
                        variableWidth: true,
                    },
                },
                {
                    breakpoint: 420,
                    settings: {
                        slidesToShow: 1.4,
                        slidesToScroll: 1,
                        variableWidth: true,
                    },
                },
            ],
        })
        .on('setPosition', function(event, slick) {
            /*slick.$slides.find('.slider__products__list__col').css('height', 'auto');
			slick.$slides.find('.slider__products__list__col').css('height', slick.$slideTrack.height() + 'px');
			$('.slider__products__content').css('height', slick.$slideTrack.height() - 45 + 'px')*/
        });
});
